import React, { useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ROUTES } from "constants/routes"
import { useOnboarding } from "context/OnboardingContext"
import OnboardingLayout from "./OnboardingLayout"
import usePlatformAuthChrome from "hooks/usePlatformAuthChrome"

const LandingPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { resetFlow } = useOnboarding()

  useEffect(() => {
    document.title = `${t("Welcome")} | Wulooj`
  }, [t])

  const handleTryNow = () => {
    resetFlow()
    navigate(ROUTES.REGISTER, { state: { startFresh: true } })
  }

  usePlatformAuthChrome(true, t("Wulooj Enterprise"))

  return (
    <OnboardingLayout showHeaderActions={true}>
      <div className="onboarding-hero-center">
      </div>
    </OnboardingLayout>
  )
}

export default LandingPage
